{
  "actions": "Műveletek",
  "hideButtonLabel": "Mutass kevesebbet",
  "noTags": "Egyik sem",
  "showAllButtonLabel": "Az összes megjelenítése ({tagCount, number})"
}
